"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = exports.ROUTER_CONTRACT = void 0;
const ethers_1 = require("ethers");
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const types_2 = require("../types");
const uniV2_1 = __importDefault(require("./abi/uniV2"));
const erc20_1 = __importDefault(require("./abi/erc20"));
const utils_1 = require("./utils");
exports.ROUTER_CONTRACT = '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D';
class Parser {
    constructor(args) {
        this.abiInterface = new ethers_1.ethers.utils.Interface(uniV2_1.default);
        this.network = args.network;
        this.provider = args.provider;
        this.addLiquidityEthSigHash = this.abiInterface.getSighash('addLiquidityETH');
        this.removeLiquidityEthSigHash = this.abiInterface.getSighash('removeLiquidityETH');
        this.wethContract = {
            mainnet: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
            ropsten: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
        }[this.network];
    }
    parse(tx) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = tx.ethereumSpecific) === null || _a === void 0 ? void 0 : _a.data))
                return;
            if (tx.confirmations !== 0)
                return;
            const sendAddress = (_c = (_b = tx.vin[0].addresses) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : '';
            switch (utils_1.getSigHash(tx.ethereumSpecific.data)) {
                case this.addLiquidityEthSigHash: {
                    const result = this.abiInterface.decodeFunctionData(this.addLiquidityEthSigHash, tx.ethereumSpecific.data);
                    const tokenAddress = ethers_1.ethers.utils.getAddress(result.token.toLowerCase());
                    const lpTokenAddress = this.pairFor(tokenAddress, this.wethContract);
                    const contract = new ethers_1.ethers.Contract(tokenAddress, erc20_1.default, this.provider);
                    const decimals = yield contract.decimals();
                    const name = yield contract.name();
                    const symbol = yield contract.symbol();
                    const value = result.amountTokenDesired.toString();
                    const transfers = [
                        {
                            type: types_2.TransferType.Send,
                            from: sendAddress,
                            to: lpTokenAddress,
                            caip19: caip_1.caip19.toCAIP19({
                                chain: types_1.ChainTypes.Ethereum,
                                network: utils_1.toNetworkType(this.network),
                                contractType: types_1.ContractTypes.ERC20,
                                tokenId: tokenAddress,
                            }),
                            totalValue: value,
                            components: [{ value }],
                            token: { contract: tokenAddress, decimals, name, symbol },
                        },
                    ];
                    return { transfers };
                }
                case this.removeLiquidityEthSigHash: {
                    const result = this.abiInterface.decodeFunctionData(this.removeLiquidityEthSigHash, tx.ethereumSpecific.data);
                    const tokenAddress = ethers_1.ethers.utils.getAddress(result.token.toLowerCase());
                    const lpTokenAddress = this.pairFor(tokenAddress, this.wethContract);
                    const contract = new ethers_1.ethers.Contract(lpTokenAddress, erc20_1.default, this.provider);
                    const decimals = yield contract.decimals();
                    const name = yield contract.name();
                    const symbol = yield contract.symbol();
                    const value = result.liquidity.toString();
                    const transfers = [
                        {
                            type: types_2.TransferType.Send,
                            from: sendAddress,
                            to: lpTokenAddress,
                            caip19: caip_1.caip19.toCAIP19({
                                chain: types_1.ChainTypes.Ethereum,
                                network: utils_1.toNetworkType(this.network),
                                contractType: types_1.ContractTypes.ERC20,
                                tokenId: lpTokenAddress,
                            }),
                            totalValue: value,
                            components: [{ value }],
                            token: { contract: lpTokenAddress, decimals, name, symbol },
                        },
                    ];
                    return { transfers };
                }
                default:
                    return;
            }
        });
    }
    pairFor(tokenA, tokenB) {
        const [token0, token1] = tokenA < tokenB ? [tokenA, tokenB] : [tokenB, tokenA];
        const factoryContract = '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f';
        const salt = ethers_1.ethers.utils.solidityKeccak256(['address', 'address'], [token0, token1]);
        const initCodeHash = '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f'; // https://github.com/Uniswap/v2-periphery/blob/dda62473e2da448bc9cb8f4514dadda4aeede5f4/contracts/libraries/UniswapV2Library.sol#L24
        return ethers_1.ethers.utils.getCreate2Address(factoryContract, salt, initCodeHash);
    }
}
exports.Parser = Parser;
